import { Model, YardSchedule } from ".";

export default class YardRentalPickupReport extends Model {
	get singularNoun() {
		return "rental pickup report";
	}

	get mutations() {
		return {
			greaterThan24HoursSchedules: YardSchedule
		};
	}

	resource() {
		return "yard/reports/rental-pickups";
	}
}
